module.exports = __webpack_public_path__ + "img/logo_bottom.63780d73.png";